import { Timestamp, addDoc, collection, doc, getDocs, orderBy, query } from "firebase/firestore";
import application from "../core/application";

export type PriceHistoryEntry = {
    id: string;
    salePrice: number;
    supplierCosts: { supplierId: string; supplierName: string; purchasePrice: number }[];
    changedAt: Date;
    changedByUserId: string;
    source: "form" | "bulk";
};

export type RecordPriceHistoryPayload = Omit<PriceHistoryEntry, "id" | "changedAt">;

export async function recordPriceHistory(productId: string, payload: RecordPriceHistoryPayload): Promise<void> {
    const historyRef = collection(doc(application.getCollection("products"), productId), "priceHistory");
    await addDoc(historyRef, { ...payload, changedAt: Timestamp.now() });
}

export async function getPriceHistory(productId: string): Promise<PriceHistoryEntry[]> {
    const historyRef = collection(doc(application.getCollection("products"), productId), "priceHistory");
    const snap = await getDocs(query(historyRef, orderBy("changedAt", "asc")));
    return snap.docs.map(d => ({
        id: d.id,
        salePrice: d.data().salePrice,
        supplierCosts: d.data().supplierCosts ?? [],
        changedAt: (d.data().changedAt as Timestamp).toDate(),
        changedByUserId: d.data().changedByUserId,
        source: d.data().source,
    }));
}
